import { render, staticRenderFns } from "./preservationDetail.vue?vue&type=template&id=42237e9b&scoped=true&lang=html&"
import script from "./preservationDetail.vue?vue&type=script&lang=js&"
export * from "./preservationDetail.vue?vue&type=script&lang=js&"
import style0 from "./preservationDetail.vue?vue&type=style&index=0&id=42237e9b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42237e9b",
  null
  
)

export default component.exports